import { backendFetch } from '../../../backend/backend';
import React, { useState, useEffect } from 'react';

import { TSTable, TSCell } from '../../ui/TableStructure';
import { TableRow, Grid } from '@mui/material';
import dateFormatter from '../../../utils/dateFormatter';

const StatsDoubles=()=>{
	const [winningStreaks,setWinningStreaks]=useState();
    const [noWinStreaks, setNoWinStreaks]=useState();

	useEffect(()=>{
		const fetchData=async ()=> {
			setWinningStreaks(await backendFetch('stats/winningstreaks'));
            setNoWinStreaks(await backendFetch('stats/nowinstreaks'));
		}
		fetchData();
	},[]);

    const StreakGridItem=({children})=>(
        <Grid item xs={2} sm={1} paddingBottom={1} paddingRight={1}>
            {children}
        </Grid>
    );

	return(
		<Grid container columns={2} >
			{winningStreaks &&
                <StreakGridItem>
                    <TSTable title="Winning Streaks" headings={["Player","Start Date","Games"]}>
                        {winningStreaks.map((d)=>(
                            <TableRow key={d.startDate}>
                                <TSCell>{d.player}</TSCell>
                                <TSCell>{dateFormatter(d.startDate)}</TSCell>
                                <TSCell>{d.games}{(d.unbroken==="true")?"*":""}</TSCell>
                            </TableRow>
                        ))}
                    </TSTable>
                </StreakGridItem>
			}
			{noWinStreaks &&
                <StreakGridItem>
                    <TSTable title="Losing Streaks" headings={["Player","Start Date","Games"]}>
                        {noWinStreaks.map((d)=>(
                            <TableRow key={d.startDate}>
                                <TSCell>{d.player}</TSCell>
                                <TSCell>{dateFormatter(d.startDate)}</TSCell>
                                <TSCell>{d.games}{(d.unbroken==="true")?"*":""}</TSCell>
                            </TableRow>
                        ))}
                    </TSTable>
                </StreakGridItem>
			}
		</Grid>
	)
}

export default StatsDoubles;
